import { cloudinaryBaseUrl } from "src/consts";

export enum ECustomerType {
  Residential = "residential",
  Business = "business",
}

const AUTO_FORMAT = "f_auto";
const C_SCALE = "c_";
const C_HEIGHT = "h_";
const C_WIDTH = "w_";
const C_QUALITY = "q_";

type ScaleType = "fill" | "fit" | "auto";
export const getCustomerType = (customerType?: string): ECustomerType => {
  if (customerType === "business") {
    return ECustomerType.Business;
  }

  return ECustomerType.Residential;
};

export const formatName = (name: string) => {
  const decodedString = decodeURI(name);
  return (
    decodedString.charAt(0).toUpperCase() + decodedString.slice(1).toLowerCase()
  );
};

export const retrieveValidLocalStorageValue = (
  localStorageName: string
): string | undefined => {
  try {
    const storageItem = window.localStorage.getItem(localStorageName);
    if (!storageItem) {
      return undefined;
    }
    return JSON.parse(storageItem).TTL > Date.now()
      ? JSON.parse(storageItem).value
      : undefined;
  } catch (err) {
    return undefined;
  }
};

export const getImageFromCloudinary = (
  height: number,
  width: number,
  path: string,
  scale: ScaleType = "fit",
  quality: number = 100
) => {
  return `${cloudinaryBaseUrl},${C_QUALITY}${quality},${AUTO_FORMAT},${C_SCALE}${scale},${C_HEIGHT}${height},${C_WIDTH}${width}${path}`;
};
